import { Text } from '@h2/components/typography/text'
import {
  InterestIcon,
  NotesIcon,
  SaveIcon,
  PlanIcon,
  SkillsIcon,
  ThumbsDownActiveIcon,
  ThumbsUpActiveIcon,
  WorkBasedLearningIcon,
  WorkImportanceIcon,
  ReportingIcon,
  BudgetYourLifeProfilerIcon,
  UtlIcon,
  CoursesIcon
} from '@h2/components/icons'
import { Link } from '@h2/common/components/link'
import { replaceVariables } from '@h2/common/utils/replaceVariables'
import { Flex } from '@h2/components/layout/flex'

const guessIcon = type => {
  switch (type) {
    case 'files':
      return <SaveIcon />
    case 'liked':
      return <ThumbsUpActiveIcon />
    case 'disliked':
      return <ThumbsDownActiveIcon />
    case 'plans':
      return <PlanIcon />
    case 'budgets':
      return <BudgetYourLifeProfilerIcon />
    case 'ip':
      return <InterestIcon />
    case 'wip':
      return <WorkImportanceIcon />
    case 'sp':
      return <SkillsIcon />
    case 'journals':
      return <NotesIcon />
    case 'wblapplication':
      return <WorkBasedLearningIcon />
    case 'mgmtreport':
      return <ReportingIcon />
    case 'utl':
      return <UtlIcon />
    case 'courses':
      return <CoursesIcon />
  }
}
const CareerHubActivity = ({ activity }) => {
  return (
    <Link href={activity.linkUrl}>
      <Flex gap="10px" alignItems="center">
        {guessIcon(activity.type)}
        <div>
          <Text margin="0 0 5px 0" weight="bold" size="medium">
            {replaceVariables(activity.title)}
          </Text>
          {activity.description && (
            <Text isItalic={true} size="medium">
              {replaceVariables(activity.description)}
            </Text>
          )}
        </div>
      </Flex>
    </Link>
  )
}

export { CareerHubActivity, guessIcon }
